<div class="c-form__items c-blocks">
  <ls-check-block
    *ngFor="let checkBlock of checkBlocks"
    [checkBlock]="checkBlock"
    (stateChange)="blockChanged()"
  >
  </ls-check-block>
</div>
